import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useShippingMethod from '@afosto/queries/fulfilment/useShippingMethod';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import getShippingMethodName from '../../../utils/getShippingMethodName';

const MethodFormatter = ({ methodId }) => {
  const intl = useIntl();
  const { data: method, isLoading } = useShippingMethod(methodId, { enabled: methodId });

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  return getShippingMethodName(intl, method) ?? '-';
};

MethodFormatter.proptypes = {
  methodId: PropTypes.string,
};

MethodFormatter.defaultProps = {
  methodId: undefined,
};

export default MethodFormatter;
